<template>
  <div>
    <v-toolbar flat>
      <v-col cols="4">
        <v-text-field
          v-model="search"
          prepend-icon="mdi-magnify"
          clearable
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-select
          v-model="status"
          :items="statuses"
          label="Status"
          dense
          hide-details
          clearable
        ></v-select>
      </v-col>
      <v-col cols="2">
        <v-select
          v-model="program"
          :items="programs"
          label="Program"
          dense
          hide-details
          clearable
        ></v-select>
      </v-col>
      <v-spacer></v-spacer>
      <new-batch-button></new-batch-button>
      <export-payment-batches></export-payment-batches>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="filteredBatches"
      :search="search"
      :loading="loading"
      sort-by="createdAt"
      sort-desc
      item-key="paymentBatchId"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-row>
          <v-btn
            text
            x-small
            color="primary"
            @click="editBatch(item)"
            v-if="!Boolean(item.postedAt)"
          >
            Edit
          </v-btn>
          <v-btn
            text
            x-small
            color="primary"
            @click="goToBatch(item, 'ProcessBatch')"
            v-if="!Boolean(item.postedAt)"
          >
            Process
          </v-btn>
          <v-btn
            text
            x-small
            color="primary"
            @click="goToBatch(item, 'ReviewBatch')"
            v-if="Boolean(item.postedAt)"
          >
            Review
          </v-btn>
          <export-batch-button
            v-if="Boolean(item.postedAt)"
            :large="false"
            :paymentBatchId="item.paymentBatchId"
          ></export-batch-button>
        </v-row>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import NewBatchButton from "./new-batch-button.vue";
import ExportPaymentBatches from "./export-payment-batches.vue";
import ExportBatchButton from "./export-batch-button.vue";
export default {
  components: {
    NewBatchButton,
    ExportPaymentBatches,
    ExportBatchButton,
  },
  async mounted() {
    this.loading = true;
    await this.$store.dispatch("paymentBatchModule/getAllBatches");
    this.loading = false;
  },
  data() {
    return {
      headers: [
        { text: "Batch ID", value: "paymentBatchId" },
        { text: "Payment Date", value: "formattedPaymentDate" },
        { text: "Payer", value: "payerName" },
        { text: "Payment Method", value: "paymentMethod", sortable: false },
        { text: "Check Number", value: "checkNumber", sortable: false },
        { text: "EFT Number", value: "eftNumber", sortable: false },
        {
          text: "Total Amount",
          value: "formattedTotalAmount",
          sortable: false,
        },
        { text: "Created On", value: "formattedCreatedAt" },
        { text: "Programs", value: "programs" },
        { text: "Posted On", value: "formattedPostedAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      loading: false,
      search: "",
      status: "",
      program: "",
    };
  },
  computed: {
    batches() {
      return this.$store.state.paymentBatchModule.batches || [];
    },
    filteredBatches() {
      var batches = this.batches;
      if (this.status) {
        batches = batches.filter((item) => item.status == this.status);
      }
      if (this.program) {
        batches = batches.filter(
          (item) =>
            item.programs != null && item.programs.includes(this.program)
        );
      }
      return batches;
    },
    statuses() {
      return ["Pending", "Posted"];
    },
    programs() {
      return this.batches.map((x) => x.programs.map((y) => y)).flat();
    },
  },
  methods: {
    editBatch(item) {
      this.$router.push({
        name: "EditBatch",
        params: {
          batch: item,
        },
      });
    },
    async goToBatch(item, routeName) {
      this.$store.commit("uxModule/setShowLoader", true);
      await this.$store.dispatch("paymentBatchModule/loadBatch", {
        paymentBatchId: item.paymentBatchId,
      });
      this.$store.commit("uxModule/setShowLoader", false);
      this.$router.push({ name: routeName });
    },
  },
};
</script>
